import styled from 'styled-components';
import credit_card from '../../../../../atoms/Icon/img/credit_card.svg';
import date from '../../../../../atoms/Icon/img/date.svg';
import cvc from '../../../../../atoms/Icon/img/cvc.svg';
var c_c = "url(".concat(credit_card, ");");
var card_date = "url(".concat(date, ");");
var card_cvc = "url(".concat(cvc, ");");
export var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-10npmrw-0"
})(["width:", ";color:black;border-top-right-radius:", ";border-top-left-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";padding-left:40px;border:2px solid;background-image:", ";background-repeat:no-repeat;border-color:", ";&:focus{outline:0;border-color:#4cbeff;}"], function (props) {
  return props.small ? '50%' : '100%';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.right ? '4px' : '0px';
}, function (props) {
  return props.left ? '4px' : '0px';
}, function (props) {
  return props.cvc ? card_cvc : props.date ? card_date : c_c;
}, function (props) {
  return props.red ? 'rgba(255, 0, 0, 0.6)' : 'rgba(14, 19, 24, 0.2)';
});
export var InputContainer = styled.div.withConfig({
  displayName: "style__InputContainer",
  componentId: "sc-10npmrw-1"
})(["position:relative;height:30px;width:auto;margin-left:12px;margin-right:12px;display:flex;"]);
export var WarningContainer = styled.div.withConfig({
  displayName: "style__WarningContainer",
  componentId: "sc-10npmrw-2"
})(["position:relative;height:100%;line-height:100%;width:auto;margin-left:12px;margin-right:12px;margin-top:10px;"]);
export var WarningLabel = styled.div.withConfig({
  displayName: "style__WarningLabel",
  componentId: "sc-10npmrw-3"
})(["position:relative;height:10px;width:auto;font-size:12px;margin-right:12px;color:#ff0000;"]);
export var Cleared = styled.div.withConfig({
  displayName: "style__Cleared",
  componentId: "sc-10npmrw-4"
})(["clear:both;"]);
export var FieldContainer = styled.div.withConfig({
  displayName: "style__FieldContainer",
  componentId: "sc-10npmrw-5"
})(["display:flex;width:100%;flex-direction:row;"]);
export var CheckoutTitle = styled.div.withConfig({
  displayName: "style__CheckoutTitle",
  componentId: "sc-10npmrw-6"
})(["font-weight:600;line-height:2;position:relative;height:25px;width:auto;margin-left:12px;color:rgba(14,19,24,0.9);margin-right:12px;"]);
export var CheckoutContainer = styled.div.withConfig({
  displayName: "style__CheckoutContainer",
  componentId: "sc-10npmrw-7"
})(["height:110px;width:100%;margin-bottom:15px;position:relative;"]);
export var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "sc-10npmrw-8"
})(["height:25px;line-height:100%;width:", ";margin:auto;margin-left:10px;font-weight:", ";color:rgba(14,19,24,0.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;z-index:", ";order:", ";min-width:100%;"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.bold ? 'bold' : 'normal';
}, function (props) {
  return props.price ? '98' : '99';
}, function (props) {
  return props.order ? props.order : '0';
});
export var HalfContainer = styled.div.withConfig({
  displayName: "style__HalfContainer",
  componentId: "sc-10npmrw-9"
})(["height:35px;line-height:100%;width:100%;order:1;min-width:100%;flex-direction:row;"]);